import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FlexLayoutModule } from '@angular/flex-layout';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { RouterModule } from '@angular/router';
import { TranslateModule } from '@ngx-translate/core';
import { BsDropdownModule } from 'ngx-bootstrap/dropdown';
import { PaginationModule } from 'ngx-bootstrap/pagination';
import { ListboxModule } from 'primeng/listbox';
import { TableModule } from 'primeng/table';
import { FormgenModule } from '../../libraries/formgen/formgen.module';
import { LibrariesModule } from '../../libraries/libraries.module';
import { SharedModule } from '../../libraries/shared.module';
import { MarketingSupportRestService } from './marketing-support-rest.service';
import { MarketingSupportRoutingModule } from './marketing-support-routing.module';
import { ButtonModule } from 'primeng/button';
import { DialogModule } from 'primeng/dialog';
import { GeneralDesignListComponent } from './generalDesign/list/list.component';
import { CustomDesignFormListComponent } from './customDesignForm/list/list.component';
import { CustomDesignReportListComponent } from './customDesignReport/list/list.component';
import { ChipModule } from '../../libraries/chip/chip.module';

export const PROVIDERS = [MarketingSupportRestService];

@NgModule({
  imports: [
    MarketingSupportRoutingModule,
    BsDropdownModule,
    CommonModule,
    FlexLayoutModule,
    FormgenModule,
    FormsModule,
    ListboxModule,
    LibrariesModule,
    PaginationModule,
    ReactiveFormsModule,
    RouterModule,
    SharedModule,
    TableModule,
    TranslateModule,
    DialogModule,
    ButtonModule,
    ChipModule
  ],
  declarations: [
    GeneralDesignListComponent,
    CustomDesignFormListComponent,
    CustomDesignReportListComponent
  ]
})
export class MarketingSupportModule {}
